import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import { runBulk } from "routes/schedule/my-schedules/my-custom-schedules/bulk-runner"
import { CustomScheduleActions } from "./selection-actions-slot-definitions"
import { clearGlobal, succeeded, retireBatch } from "./selection-actions-helpers"

CustomScheduleActions.plug(
    <RetirePublishedButton if={({ publishedItems = [] }) => publishedItems.length} priority={10} />
)

export function RetirePublishedButton() {
    const { publishedItems = [] } = useBoundContext()

    return (
        <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="bx:box" />}
            onClick={retirePublished}
            data-cy="bulk-retire"
        >
            Retire {publishedItems.length}
        </Button>
    )

    async function retirePublished() {
        const count = publishedItems.length
        const ok = await confirm(
            "These move to your Retired list and are hidden. To bring them back, select them from the retired view and restore.",
            `Retire ${count} published ${"schedule".pluralize(count)}`,
            undefined,
            "Retire",
            { okIcon: "bx:box", cancelIcon: "mdi:close-circle-outline" }
        )
        if (!ok) return
        const ids = publishedItems.map((m) => m._id)
        const { failed } = await runBulk(ids, { progress: "Retiring", past: "Retired" }, retireBatch(true))
        clearGlobal(succeeded(ids, failed))
    }
}
